document.addEventListener('DOMContentLoaded', function() {
    crearGaleria();
});

function crearGaleria() {
    const galeria = document.querySelector('.galeria-imagenes');

    
    for( let i = 1; i<= 12; i++ ) {
        const imagen = document.createElement('IMG');
        imagen.src = `build/img/thumb/${i}.webp`;
        imagen.dataset.imageID = i;

        //Añadir la funcion de mostrar imagen
        imagen.onclick = mostrarImagen;

        const lista = document.createElement('li');
        lista.appendChild(imagen);

        galeria.appendChild(lista);
    }
}

function mostrarImagen(e) {
    
    const id = parseInt( e.target.dataset.imageID );

    // Generar la imagen grande 

    const imagen = document.createElement('img');
    imagen.src = `build/img/grande/${id}.webp`;

   const overlay = document.createElement('div');
   overlay.appendChild(imagen);
   overlay.classList.add('overlay');

  

   //Boton para cerrar imagen grande

   const cerrarImagen = document.createElement('p');
   cerrarImagen.textContent = 'X';
   cerrarImagen.classList.add('btn-cerrar');

  

   //Cuando se presiona x se cierra la imagen grande

   cerrarImagen.onclick = function() {
       overlay.remove();
       body.classList.remove('fijar-body');
   }

    //Cuando se presiona por fuera tambien cierra imagen

    overlay.onclick = function() {
        overlay.remove();
        body.classList.remove('fijar-body');
    }

    overlay.appendChild(cerrarImagen);

   

   //Mostrar imagen grande en Html

    const body = document.querySelector('body');
    body.appendChild(overlay);
    body.classList.add('fijar-body');
}